import {Button, TextField} from '@material-ui/core';
import React from 'react';
import {useFormContext} from 'react-hook-form';
import {APIUrlDefault} from '../../../utils/configuration';
import { DropzoneArea } from 'material-ui-dropzone';

const ProjectImageTw = ({
  isShowTw = false,
    fileTw = [],
    fileUploadTwt = [],
    onOpenSelectFileTw = () => { },
  setFileUploadTwt = () => {}
}) => {
  const {register, errors} = useFormContext();

  return (
      <>
          <div className="form-group row">
              <div className="col-12">
                  <label className="text-dark">Ảnh Twitter</label>
                  {!isShowTw &&
                      fileTw &&
                      fileTw.length > 0 &&
                      fileTw.map(item => (
                          <div key={item.fileName} style={{ width: '150px' }}>
                              <img
                                  src={APIUrlDefault + item?.filePreview}
                                  alt={item.fileName}
                                  className="img-fluid mb-2"
                                  style={{
                                      width: 'auto',
                                      height: 'auto',
                                      maxWidth: '100%',
                                      maxHeight: '100%'
                                  }}
                              />
                          </div>
                      ))}
                  <div>
                      {
                          //            <Button
                          //                variant="contained"
                          //                color="primary"
                          //                onClick={onOpenSelectFileTw}
                          //            >
                          //                Chọn file
                          //</Button>
                      }
                      <TextField
                          type="hidden"
                          value={(fileUploadTwt && fileUploadTwt.length > 0 && fileUploadTwt[0].name) || ''}
                      />
                  </div>
              </div>
          </div>
          <div className="col-12">
              <DropzoneArea
                  acceptedFiles={['image/png, image/gif, image/jpeg, image/jpg']}
                  filesLimit={1}
                  dropzoneText="Kéo thả ảnh share twitter vào đây"
                  onChange={(files) => {
                      setFileUploadTwt(files);
                  }}
              />
          </div>
      </>
  );
};

export default ProjectImageTw;
